import styled from "styled-components";
import { colors, darkModeColors } from "../../consts";
import { TextButton } from "../../components";

export const TabButtonStyled = styled(TextButton)`
  font-weight: ${(props) => (props?.active ? 500 : 400)};

  color: ${(props) =>
    props?.active ? darkModeColors.RAISIN_100_WHITE : darkModeColors.RAISIN_80_RAISIN_20};

  background: ${(props) =>
    props?.active
      ? props?.theme?.darkMode
        ? colors.RAISIN_100
        : `rgba(52, 48, 61, 0.1)`
      : darkModeColors.ISABELLINE_DARK_RAISIN};

  border: 1px solid;
  border-color: ${(props) =>
    props?.active ? darkModeColors.RAISIN_100_RAISIN_40 : darkModeColors.IRON_RAISIN_80};

  border-radius: 8px;

  padding: 0 10px;

  display: flex;
  flex-direction: row;
  align-items: center;

  &:hover {
    opacity: 1;
    color: ${darkModeColors.RAISIN_100_WHITE};
  }
`;
